export default "__VITE_ASSET__B$VnVmtX__"